import { ThumbsDown, ThumbsUp } from "lucide-react";
import { cn } from "@/lib/utils";

export type FeedbackRating = "positive" | "negative";

interface FeedbackButtonsProps {
  rating?: FeedbackRating | null;
  isLoading?: boolean;
  onThumbsUp?: () => void;
  onThumbsDown?: () => void;
}

export function FeedbackButtons({
  rating = null,
  isLoading = false,
  onThumbsUp,
  onThumbsDown,
}: FeedbackButtonsProps) {
  const isPositive = rating === "positive";
  const isNegative = rating === "negative";

  return (
    <div
      className={cn(
        "flex items-center gap-2 transition-opacity",
        rating ? "opacity-100" : "opacity-0 group-hover:opacity-100"
      )}
    >
      <button
        type="button"
        className="rounded p-1 transition-colors hover:bg-neutral-100 disabled:cursor-not-allowed disabled:opacity-60"
        aria-label="Thumbs up"
        aria-pressed={isPositive}
        title="Thumbs up"
        onClick={onThumbsUp}
        disabled={isLoading}
      >
        <ThumbsUp
          className={cn(
            "h-4 w-4",
            isPositive
              ? "fill-current text-neutral-600"
              : "text-neutral-400 group-hover:text-neutral-600"
          )}
        />
      </button>
      <button
        type="button"
        className="rounded p-1 transition-colors hover:bg-neutral-100 disabled:cursor-not-allowed disabled:opacity-60"
        aria-label="Thumbs down"
        aria-pressed={isNegative}
        title="Thumbs down"
        onClick={onThumbsDown}
        disabled={isLoading}
      >
        <ThumbsDown
          className={cn(
            "h-4 w-4",
            isNegative
              ? "fill-current text-neutral-600"
              : "text-neutral-400 group-hover:text-neutral-600"
          )}
        />
      </button>
    </div>
  );
}

FeedbackButtons.displayName = "FeedbackButtons";
